const ApiMapper = {
  AUTH: {
    LOGIN: '/login/check',
    LOGINTOKEN: '/authenticate',
    LOGOUT: '/revoke',
    SUBMIT: '/user/service',
    UPDATE_PW: '/auth/update/password',
  },
  SERVICE_AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
  },
  MANAGEMENT: {
    DOMAIN_KIND_CD: 'common/code-list/DOMAIN_KIND_CD',
    GET_DEPT_LIST: 'management/users/select/box/dept',
    GET_SGG_LIST: 'management/users/select/box/sgg',
    USER_LIST: 'management/users',
    USER_TOTAL_COUNT: 'management/users/count',
    USER_DETAIL: 'management/users/',
    USER_PW_RESET: 'management/users/init/password',
    LOGIN_LIST: '/management/users/access/logs',
    LOGIN_TOTAL_COUNT: '/management/users/access/logs/count',
    LOGIN_EXCEL_DOWNLOAD: '/management/users/access/logs/excel/download',
    SERVICE_LIST: '/management/users/service/logs',
    SERVICE_TOTAL_COUNT: '/management/users/service/logs/count',
    SERVICE_EXCEL_DOWNLOAD: '/management/users/service/logs/excel/download',
  },
};

export default ApiMapper;
